module.exports = __webpack_public_path__ + "static/img/banner3.5b9d0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/banner3.png
// module id = YDZV
// module chunks = 1